<template>
  <div>
    <div class="wreppar">
      <div>
        <Header></Header>
      </div>
      <div class="centent">
        <div class="centent_child">
          <div class="section">
            <div class="re_dian zi_xun">
              <p class="dian_shi">新闻资讯</p>
              <p class="dian_wen">MORE</p>
            </div>
            <div class="dian_zi" v-for="(item,index) in newData">
              <p @click="details(index)">{{item.title}}</p>
            </div>
          </div>
          <div class="centent_right">
            <div class="centent_title">{{ajaxData.title}}</div>
            <div v-html="ajaxData.Details" class="centent_nei"></div>
          </div>
        </div>
      </div>
      <div>
        <Footer></Footer>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header.vue";
import Footer from "../footer/footer.vue";
import Section from "../section/section.vue";
export default {
  data() {
    return {
      ajaxData: [],
      id: "",
      newData: []
    };
  },
  components: { Header, Footer, Section },
  watch: {},
  methods: {
    details: function(a) {
      let that = this;
      that.$http
        .get(that.g.ajaxurl + "attentions/news?id=" + this.newData[a].id)
        .then(res => {
          that.ajaxData = res.data.data;
          console.log(that.ajaxData);
        });
    },
    games_app: function() {
      let that = this;
      let token = JSON.parse(localStorage.getItem("username")).code;
      that.$http
        .get(that.g.ajaxurl + "teams/new", {
          headers: {
            Authorization: "Basic " + window.btoa(token + ":")
          }
        })
        .then(res => {
          this.newData = res.data.data;
        });
    }
  },
  mounted() {
    this.id = this.$route.query.id;
    let that = this;
    that.$http
      .get(that.g.ajaxurl + "attentions/news?id=" + this.id)
      .then(res => {
        that.ajaxData = res.data.data;
        console.log(that.ajaxData);
      });
    this.games_app();
  }
};
</script>
<style scoped="scoped">
* {
  margin: 0;
  padding: 0;
}
.wreppar {
  width: 100%;
}
.centent {
  width: 100%;
  padding-top: 2rem;
}
.centent_child {
  width: 70%;
  margin: 0 auto;
  display: flex;
  justify-content: flex-start;
}
.section {
  width: 26%;
}
.centent_right {
  margin-left: 10%;
  width: 66%;
}
.centent_title {
  font-size: 0.34rem;
  border-bottom: solid 1px #000;
  padding: 0.2rem 0;
  text-align: center;
}
.centent_nei {
  font-size: 0.24rem;
}
.re_dian {
  width: 100%;
  border-bottom: solid 2px #e50005;
  display: flex;
  justify-content: space-between;
}
.dian_shi {
  font-size: 0.2rem;
  background: #e50005;
  line-height: 0.4rem;
  color: #fff;
  padding: 0 0.3rem;
  border-radius: 5px 5px 0 0;
}
.dian_wen {
  font-size: 0.2rem;
  color: #e50005;
  line-height: 0.4rem;
}
.zi_xun {
  margin-top: 0.3rem;
}
.dian_zi {
  width: 100%;
}
.dian_zi p {
  line-height: 0.3rem;
  border-bottom: solid 1px #ccc;
  font-size: 0.2rem;
  overflow: hidden;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 0.1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/chessnews.vue